export interface EventTrackingContext {
  template_id?: number;
  funnel_source?: string;
  env?: string;
  topic_name?: string;
  region?: string;
  user_preferred_currency?: string;
  domain_country?: string;
  domain_language?: string;
  domain_currency?: string;
  funnel_entry?: string;
  organisation?: string;
  bu?: string;
  traffic_source?: string;
}

export interface Context {
  template_id?: number;
  topic_name?: string;
}

export interface PageContext {
  page_name?: string;
  lob?: string;
  lob_category?: string;
  page_type?: string;
  funnel_step?: string;
  subpage_name?: string;
  page_url?: string;
}

export interface SearchContext {
  [key: string]: any;
}

export interface ExperimentDetails {
  variant_keys?: string;
  honoured_exp_list?: any[];
}

export interface ProductList {
  id?: string;
}

/** Java-style component item: one entry in the components list (product_list + content_details + component_type + position) */
export interface ComponentItem {
  product_list?: ProductList[];
  content_details?: ComponentViewData[];
  component_type?: string;
  position?: { h?: number | string; v?: number | string };
}

export interface EventDetail {
  /** List of component items (Java format). Each item has product_list, content_details, component_type, position. */
  components?: ComponentItem[];
  event_type?: string;
  event_name?: string;
  event_value?: string;
  booking_info?: {
    booking_id?: string | undefined;
    status?: string | null;
    price?: number | null;
    payment_method?: string | null;
  };
  [key: string]: any;
}

export interface ErrorDetailsList {
  code?: string;
  message?: string;
  source?: string;
  severity?: string;
}
export interface PageInitializationData {
  event_tracking_context?: EventTrackingContext;
  context?: Context;
  page_context?: PageContext;
  search_context?: SearchContext | null;
  experiment_details?: ExperimentDetails;
  event_detail?: EventDetail;
  error_details_list?: ErrorDetailsList[];
}

export interface ManualEventData {
  event_tracking_context?: EventTrackingContext;
  context?: Context;
  page_context?: PageContext;
  search_context?: SearchContext | null;
  experiment_details?: ExperimentDetails;
  event_detail?: EventDetail;
  adobe_analytics?: any;
  error_details_list?: ErrorDetailsList[];
}

export interface AnalyticsEventObject {
  event_tracking_context: EventTrackingContext;
  context: Context;
  page_context?: PageContext;
  search_context?: SearchContext | null;
  experiment_details?: ExperimentDetails;
  event_detail?: EventDetail;
  event_id: string;
  timestamp: number;
}

export interface SearchContextParams {
  isStoreSearchContext?: boolean;
  isReadStoreSearchContext?: boolean;
  countries?: {
    code: string;
    name: string;
    locusId?: string;
    locusType?: string;
    [key: string]: any;
  }[];
  fromDateTime?: number;
  toDateTime?: number;
  journeyType?: string;
  travellers?: number;
}

export interface ComponentViewInput {
  /** Name of the component being tracked */
  name: string;
  /** Type of component (e.g., 'card', 'button', 'modal') */
  type: string;
  /** Optional tracking key for analytics */
  tracking_key?: string;
  /** Optional card component identifier */
  card_component?: string;
}

export interface ComponentViewData {
  /** Unique identifier for the component view instance */
  id: string;
  /** Name of the component being tracked */
  name: string;
  /** Type of component (e.g., 'card', 'button', 'modal') */
  type: string;
  /** Optional tracking key for analytics */
  tracking_key?: string;
  /** Number of times this component has been viewed */
  view_frequency: number;
  /** Optional position data */
  position?: {
    v?: number;
    h?: number;
  };
  /** Optional card component identifier */
  card_component?: string;
}

export interface ComponentViewResult {
  /** Array of all tracked components */
  components: ComponentViewData[];
  /** Total number of unique components tracked */
  totalComponents: number;
  /** Total number of views across all components */
  totalViews: number;
  /** Timestamp when the data was retrieved */
  retrievedAt: number;
}
